webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(5);




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */], {});

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Swiper_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Swiper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Swiper_vue__);
/**!
 * @license MIT
 * Alex.Wen
 * Xi'an
 * wenxinghua1990@163.com
 */



var swiperplugin = {};
swiperplugin.installed = false;

swiperplugin.install = function (Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (swiperplugin.installed) {
    return;
  }

  Vue.component('swiper', __WEBPACK_IMPORTED_MODULE_0__components_Swiper_vue___default.a);
  swiperplugin.installed = true;
};
/* harmony default export */ __webpack_exports__["a"] = (swiperplugin);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['images', 'size'],
  data: function data () {
    return {
        cur_index: 0,
        axixX: 0,
        duration: '0.3s',
        interval: null,
        transitioning: false
    }
  },
  computed: {
    container_width: function () {
        return this.size.width * this.compouted_images.length + 'px'
    },
    translate3d: function () {
        return '(' + this.axixX + 'px, 0, 0)'
    },
    /**
     * 图片数据进行加工，栈顶栈底分别插入一组数据
     * 类似 3，1，2，3，1
     */
    compouted_images: function () {
        var newImages = Object.assign([], this.images)
        // 首尾分别添加对应元素
        newImages.splice(0, 0, this.images[this.images.length - 1])
        newImages.push(this.images[0])
        return newImages
    }
  },
  created: function () {
    this.axixX = -this.size.width
    // 自动播放图片
    this.interval = setInterval(this.turnToNext, 3000)
  },
  methods: {
    /**
     * 手动向前滚动图片 
     */
    turnToPre: function () {
        if (this.transitioning) {
            return
        }
        this.duration = '0.3s'
        this.transitioning = true
        if (this.cur_index === 0) {
            this.axixX += this.size.width
            this.cur_index = this.images.length - 1
        } else {
            this.axixX += this.size.width
            this.cur_index --
        }
    },
    /**
     * 手动向后滚动图片
     */
    turnToNext: function () {
        if (this.transitioning) {
            return
        }
        this.transitioning = true
        this.duration = '0.3s'
        if (this.cur_index === this.images.length - 1) {
            this.axixX -= this.size.width
            this.cur_index = 0
        } else {
            this.axixX -= this.size.width
            this.cur_index ++
        }
    },
    increment: function () {
        // 父组件触发该事件
        this.$emit('clickimg', this.cur_index)
    },
    transitionend: function () {
        if (this.cur_index === 0) {
            this.duration = 'inherit'
            this.axixX = -this.size.width
        } else if (this.cur_index === this.images.length - 1) {
            this.duration = 'inherit'
            this.axixX = -this.size.width * this.images.length
        }
        this.transitioning = false
    },
    /**
     * select pagination item
     **/
    selectItem: function (index) {
        console.log('selected' + index)
        if (this.transitioning) {
            return
        }
        this.transitioning = true
        this.duration = '0.3s'
        this.axixX = -this.size.width * (index + 1)
        this.cur_index = index
    }
  }
});


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_111_jpg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_111_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_111_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_222_jpg__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_222_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_222_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_333_jpg__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_333_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_333_jpg__);
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data () {
      return {
        imgSize: {
          width: 520,
          height: 280
        },
        swiperSrcs: [
            {src: __WEBPACK_IMPORTED_MODULE_0__assets_images_111_jpg___default.a},
            {src: __WEBPACK_IMPORTED_MODULE_1__assets_images_222_jpg___default.a},
            {src: __WEBPACK_IMPORTED_MODULE_2__assets_images_333_jpg___default.a}
        ]
      }
  },
  methods: {
    click_img: function (index) {
      console.log(index)
    }
  }
});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, "\n.mySwiper[data-v-7e3da450] {\n  margin: 0 auto;\n}\n", ""]);

// exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, "\n.carousel-control, .carousel-control > .pre_and_next {\n  width: inherit;\n  height: inherit;\n}\n@font-face {\n  font-family: \"iconfont\";\n  src: url(\"//at.alicdn.com/t/font_f67mfryclerk9.eot\");\n  src: url(\"//at.alicdn.com/t/font_f67mfryclerk9.eot?#iefix\") format(\"embedded-opentype\"), url(\"//at.alicdn.com/t/font_f67mfryclerk9.woff\") format(\"woff\"), url(\"//at.alicdn.com/t/font_f67mfryclerk9.ttf\") format(\"truetype\"), url(\"//at.alicdn.com/t/font_f67mfryclerk9.svg#iconfont\") format(\"svg\");\n}\n.iconfont {\n  font-family: \"iconfont\" !important;\n  font-size: 3em;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.swiper-show-container {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n.swiper-show-container:hover .pre_and_next, .swiper-show-container:focus .pre_and_next {\n    transition-duration: 2s;\n    display: block;\n}\n.swiper-container {\n  position: absolute;\n  transition-duration: 0.3s;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n.swiper-container > .image-container {\n    float: left;\n}\n.carousel-control {\n  position: absolute;\n}\n.carousel-control > .pre_and_next {\n    position: absolute;\n    top: 50%;\n    display: none;\n}\n.carousel-control .pre-btn, .carousel-control .next-btn {\n    display: inline-block;\n    position: absolute;\n}\n.carousel-control .pre-btn > a, .carousel-control .next-btn > a {\n      width: 48px;\n      height: 42px;\n      display: block;\n      background: transparent;\n}\n.carousel-control .pre-btn {\n    left: 0;\n}\n.carousel-control .pre-btn > a:before {\n      content: '\\E77A';\n}\n.carousel-control .next-btn {\n    right: 0;\n}\n.carousel-control .next-btn > a:before {\n      content: '\\E776';\n}\n.pagination {\n  border-radius: 10px;\n  position: absolute;\n  bottom: 15px;\n  height: 13px;\n  text-align: center;\n  font-size: 0;\n  left: 50%;\n  margin-left: -39px;\n  background-color: rgba(255, 255, 255, 0.3);\n  display: block;\n}\n.pagination > .pagination-item {\n    list-style: none;\n    display: inline-block;\n    margin: 2px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #ececec;\n}\n.pagination > .pagination-item.selected {\n      background: #d33c3e;\n}\n", ""]);

// exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/111.1d0ddeb.jpg";

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/222.c4cd156.jpg";

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/333.76bf594.jpg";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(16),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(15),
  /* scopeId */
  "data-v-7e3da450",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mySwiper"
  }, [_c('swiper', {
    attrs: {
      "images": _vm.swiperSrcs,
      "size": _vm.imgSize
    },
    on: {
      "clickimg": _vm.click_img
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-show-container",
    style: ({
      width: _vm.size.width + 'px',
      height: _vm.size.height + 'px'
    }),
    on: {
      "click": _vm.increment
    }
  }, [_c('div', {
    staticClass: "swiper-container",
    style: ({
      width: _vm.container_width,
      transform: 'translate3d' + _vm.translate3d,
      transitionDuration: _vm.duration
    }),
    on: {
      "transitionend": _vm.transitionend
    }
  }, _vm._l((_vm.compouted_images), function(item, index) {
    return _c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      style: ({
        width: _vm.size.width + 'px',
        height: _vm.size.height + 'px'
      }),
      attrs: {
        "src": item.src
      }
    })])
  })), _c('div', {
    staticClass: "carousel-control"
  }, [_c('div', {
    staticClass: "pre_and_next iconfont"
  }, [_c('li', {
    staticClass: "pre-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.turnToPre($event)
      }
    }
  })]), _c('li', {
    staticClass: "next-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.turnToNext($event)
      }
    }
  })])]), _c('ul', {
    staticClass: "pagination"
  }, _vm._l((_vm.images), function(pagItem, pagInex) {
    return _c('li', {
      staticClass: "pagination-item",
      class: {
        'selected': pagInex === _vm.cur_index
      },
      on: {
        "click": function($event) {
          _vm.selectItem(pagInex)
        }
      }
    })
  }))])])
},staticRenderFns: []}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1ea71d8f", content, true);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("265b5c4e", content, true);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ })
],[21]);


// WEBPACK FOOTER //
// js/example.build.js